import { css } from 'styled-components';

import { transformStylesToVariants } from '../utils/transformStylesToVariants';

const headerVariants = {
  h1: css`
    font-size: 90px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: 2px;
    text-transform: uppercase;
  `,
  h1Alt: css`
    font-size: 45px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: 1px;
    text-transform: uppercase;
  `,
  h2: css`
    font-size: 24px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: 1px;
    text-transform: uppercase;
  `,
  h3: css`
    font-size: 20px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: 1px;
    text-align: left;
    text-transform: uppercase;
  `,
};

export const themeTokens = {
  checkoutDefaultLayout: {
    wrapper: css``,
  },
  logoAndPageNameHeader: {
    wrapper: css``,
    styledLink: css``,
    pageNameWrapper: css``,
  },
  cart: {
    styledCountdownTimerHeader: css``,
  },
  errorInputV2: {
    defaultStyle: css``,
  },
  inputV2: {
    defaultStyle: css``,
    inputErrorStyle: css``,
  },
  inputBoxV2: {
    defaultStyle: css``,
    inputBoxErrorStyle: css``,
    adyenStyle: css``,
  },
  labelInputV2: {
    defaultStyle: css``,
    labelInputErrorStyle: css``,
  },
  spacing: {
    none: 0,
    tiny: 8,
    small: 16,
    moderate: 24,
    medium: 32,
    large: 40,
    xlarge: 80,
  },
  button: {
    defaultStyle: css``,
  },
  collapsibleTrigger: {
    defaultStyle: css``,
    collapsibleButton: css``,
  },
  inputBox: {
    defaultStyle: css``,
    inputBoxErrorStyle: css``,
  },
  input: {
    defaultStyle: css``,
    inputErrorStyle: css``,
  },
  labelInput: {
    defaultStyle: css``,
    labelInputErrorStyle: css``,
  },
  errorInput: {
    defaultStyle: css``,
  },
  joinVipAnnual: {
    shared: {
      styledText: css``,
      learnMoreLink: css``,
    },
  },
  basketItemPrice: {
    basketPrice: css``,
    priceLabel: css``,
  },
  basketItemDetails: {
    basketPricePromo: css``,
  },
  basketItem: {
    productName: css``,
  },
  basicModal: {
    dialogStyle: css``,
  },
  productDetailName: {
    productName: css``,
  },
  productDetailHeader: {
    promoTextWrapper: css``,
  },
  productDetailSizeSelector: {
    sizeCategoryLabel: css``,
  },
  colorSwatch: {
    colorTitle: css``,
  },
  confirmationButton: css``,
  quickViewModal: {
    styledLink: css``,
  },
  selectV2: {
    errorStyle: css``,
    errorHintStyle: css``,
    listStyle: css``,
    itemStyle: css``,
    buttonStyle: css``,
    labelStyle: css``,
    wrapperStyle: css``,
    quizStyle: css``,
    defaultStyle: css``,
  },
  countdownTimerHeader: {
    countdownTimerWrapper: css``,
    styledCountdown: css``,
  },
  hintInputV2: {
    defaultStyle: css``,
  },
  header: {
    variants: transformStylesToVariants(headerVariants, 'textStyles'),
  },
  promoCode: {
    styledApplyButton: css``,
  },
  totalPriceSummary: {
    subHeader: css``,
    shippingAndTaxesDisclaimer: css``,
  },
  cartUpsellCarousel: {
    title: css``,
    styledArrowButton: css``,
  },
  productCellBmig: {
    quickShopLabel: css``,
    productName: css``,
  },
  memberCreditsCartToggleNmp: {
    textStyled: css``,
  },
  memberCreditBenefitsModal: {
    title: css``,
    item: css``,
    buttonLink: css``,
    faQuestionCircleStyled: css``,
  },
  memberCreditsCartToggleButton: {
    toggleButtonStyled: {
      applied: css``,
      unavailable: css``,
      default: css``,
    },
  },
  orderDetails: {
    field: css``,
    nestedTitle: css``,
  },
  klarnaMessaging: {
    klarnaMessagingWrapper: css``,
  },
  trustPilotMessage: {
    checkoutSection: {
      trustPilotCheckoutSection: css``,
      title: css``,
    },
    poweredByText: css``,
  },
  checkoutSection: {
    title: css``,
  },
};
